import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ExecuteChangeServerResponse } from 'src/app/firm-settings/bulk-handling/interfaces/bulk-change.component';
import { environment } from 'src/environments/environment';
import { HttpAuthorizationHeader } from '../misc/httpauthorizationheader';
import { BLService } from './bl.service';

@Injectable()
export class BulkService extends BLService {
  private options = new HttpAuthorizationHeader('application/json');
  private RESOURCE_ENDPOINT = 'bulk-change';
  private url = environment.serverUrlV2 + this.RESOURCE_ENDPOINT;

  change(data: any): Observable<ExecuteChangeServerResponse> {
    const options = this.options.getAuthorizationHeaderWithoutContentType();
    // const data = {
    //   actionType: 'CHANGE_RESPONSIBLE_USER',
    //   changes: [],
    //   rows: [],
    // };
    return this.http.put<ExecuteChangeServerResponse>(this.url, data, options).pipe(this.catchErrorAndShowMessage());
  }
}
